import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'status', en);
i18next.addResources('fr', 'status', fr);

declare global {
  interface RegisteredLocales {
    status: typeof en;
  }
}
